<script>
/**
 * Un champ du panneau avancé: son intitulé au-dessus, le contrôle en dessous.
 *
 * Sans intitulé, un panneau de dix champs ne se lit qu'en devinant ce que
 * chaque contrôle filtre — une liste déroulante refermée ne dit plus rien de
 * ce qu'elle règle.
 */
export default {
  name: 'FilterField',
  props: {
    label: { type: String, required: true },
    /** Occupe deux colonnes de la grille: un intervalle de dates, par exemple. */
    wide: { type: Boolean, default: false },
  },
};
</script>

<template>
  <div class="filter-field" :class="{ 'filter-field--wide': wide }">
    <span class="filter-field__label">{{ label }}</span>
    <slot></slot>
  </div>
</template>
